import LandingPage from "pages/landing";
import SingleVideoPage from "pages/videos/single-video";
import DocumentsPage from "pages/documents";
import { Link, Route, Routes } from "react-router-dom";
import "./App.css";

function NotFound() {
  return (
    <div className="bg-gray-200 min-h-screen py-16">
      <div className="max-w-4xl mx-auto bg-white p-8 text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Page not found</h1>
        <p className="text-gray-600 mb-6">
          This page doesn't exist or may have moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-primary hover:bg-primary-600 transition-colors duration-200 text-white rounded px-6 py-3 font-bold"
        >
          View All Training Videos
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <>
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/videos/:id" element={<SingleVideoPage />} />
        <Route path="/documents/:id" element={<DocumentsPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
